import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
	selector: 'logout',
	templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

	constructor(
		private msalService: MsalService,
		private router: Router,
		private spinner: SpinnerVisibilityService) { }

	async ngOnInit() {
		this.spinner.show();
		
		try {
			// Perform popup logout
			localStorage.clear();
  			sessionStorage.clear();

			this.msalService.logoutRedirect().subscribe({
				next: () => {
					// After successful logout, navigate to login page
					this.router.navigate(['/login']);
				},
				error: (error) => {
					console.error('Logout error:', error);
				}
			});
		} catch (error) {
			console.error("Logout failed: ", error);
		
			// Fallback to redirect-based logout if popup fails
			try {
			await this.msalService.logoutRedirect();
			} catch (redirectError) {
			console.error("Redirect-based logout failed: ", redirectError);
			}
		} finally {
			this.spinner.hide();
		}
	}
}